import React, { useContext } from "react";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { Controller } from "react-hook-form";
import { formContext } from "../formContext";
import VendorMultiSelect from "../../../components/VendorMultiSelect";

export const VendorSelectField = (): JSX.Element => {
  const { errors, control } = useContext(formContext);

  if (!errors) {
    throw new Error(
      "VendorMultiSelect must be in formContext tree 'errors' is not defined"
    );
  }

  if (!control) {
    throw new Error(
      "VendorMultiSelect must be in formContext tree 'control' is not defined"
    );
  }

  return (
    <FormControl mb="4" isInvalid={!!errors.vendors}>
      <FormLabel>Vendors</FormLabel>
      <Controller
        name="vendors"
        control={control}
        render={({ field: { onChange, value } }) => {
          return <VendorMultiSelect value={value} onChange={onChange} />;
        }}
      />
    </FormControl>
  );
};
